import React from "react";
import { AuthConsumer } from "../../providers/AuthProvider";
import Loader from "../../helpers/loader-full";

export const Callback = () => (
  <AuthConsumer>
    {({ signinRedirectCallback }) => {
      signinRedirectCallback();
      return <Loader full={true} />;
    }}
  </AuthConsumer>
);

export const LoginWidget = () => (
  <AuthConsumer>
    {({ signinRedirectCallback }) => {
      signinRedirectCallback();
      return <Loader edenredLogo={true} full={true} />;
    }}
  </AuthConsumer>
);

export const LogoutWidget = ({ history }) => (
  <AuthConsumer>
    {({ logout }) => {
      logout({ history });
      return <Loader edenredLogo={true} full={true} />;
    }}
  </AuthConsumer>
);
